/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
import { Alert, Button, Group, Paper, Space, Text, ThemeIcon } from '@mantine/core';
import { IconCalendarEvent, IconCircleX, IconDeviceFloppy, IconId, IconZoomMoney } from '@tabler/icons-react';
import { Tabs } from 'antd';
import { useMemo, useRef, useState } from 'react';
import RecurrenceForm from '../../../../../../../components/core/Recurrence/RecurrenceForm';
import { ProposalGeneralData } from '../../../../../../../contexts/core/proposals/ProposalGeneral.context';
import { useProposalServiceContext } from '../../../../../../../contexts/core/proposals/ProposalService.context';
import { EntityTypeType, UnitOfMeasureType } from '../../../../../../../models/core/cache.type';
import { Action } from '../../../../../../../models/core/core.type';
import {
  ProposalResiduePlanPricingType,
  ProposalServiceQuotationType,
  ProposalServiceType,
  ProposalTipoPrecificacaoEnum,
} from '../../../../../../../models/core/proposals.type';
import { EntityItemEnum, Feature } from '../../../../../../../utils/constants.utils';
import ServiceGeneralFormView from './components/ServiceGeneralFormView';
import ServiceQuotationEditor from './components/ServiceQuotationEditor';

type ProposalFormViewProps = {
  referenceData: {
    unitOfMeasures: UnitOfMeasureType[];
    entityTypeData: EntityTypeType[];
  };
  proposalGeneralData: ProposalGeneralData;
  origItem: ProposalServiceType | null;
  item: ProposalServiceType | null;
  idProposta: number | undefined;

  callback(item: ProposalServiceType | null, action: string, confirmed: boolean): void;
  zIndex: number;
  defaultActiveKey?: string;
  initialQuotationItem?: ProposalServiceQuotationType | null;
  initialQuotationTab?: string;
  autoOpenQuotationModal?: boolean;
};

export default function ServiceFormAddEdit(props: ProposalFormViewProps) {
  const disabled = false; // !!props.item?.idPropostaServicoPai;
  const { proposalServiceData } = useProposalServiceContext();

  const [error, setError] = useState<any | null>(null);
  const [quotationsData, setQuotationsData] = useState<ProposalServiceQuotationType[]>(
    props.item?.cotacoes.map((quotation) => ({
      ...quotation,
      action: quotation.action || Action.Nothing,
      id: quotation.id || quotation.idPropostaServicoCotacao?.toString() || quotation.idTemporaria,
    })) || []
  );

  const refGeneralForm = useRef<any>();
  const refRecorrenciaForm = useRef<any>();

  const currentServiceData = useMemo<ProposalServiceType>(
    () => ({
      ...(props.item || ({} as ProposalServiceType)),
      cotacoes: quotationsData,
      idProposta: props.idProposta || props.item?.idProposta || -1,
      idServico: proposalServiceData.servico?.idServico || props.item?.idServico || -1,
      servico: proposalServiceData.servico?.servico || props.item?.servico || '',
      servicoDescricao: proposalServiceData.servico?.descricao || props.item?.servicoDescricao || null,
      quantidade: proposalServiceData.quantidade || props.item?.quantidade || 0,
      precificacao: proposalServiceData.precificacao ||
        props.item?.precificacao || {
          tipo: ProposalTipoPrecificacaoEnum.Geral,
          quantidade: null,
          quantidadeIdUnidadeMedida: null,
          quantidadeUnidadeMedida: null,
          quantidadeUnidadeMedidaSigla: null,
          frequenciaIdUnidadeMedida: null,
          frequenciaUnidadeMedida: null,
          frequenciaUnidadeMedidaSigla: null,
          preco: null,
          imposto: null,
        },
      frequencia: proposalServiceData.frequencia || props.item?.frequencia || null,
      frequenciaIdUnidadeMedida1:
        proposalServiceData.frequenciaIdUnidadeMedida1 || props.item?.frequenciaIdUnidadeMedida1 || null,
      frequenciaIdUnidadeMedida2:
        proposalServiceData.frequenciaIdUnidadeMedida2 || props.item?.frequenciaIdUnidadeMedida2 || null,
      idResiduoAcondicionamento:
        proposalServiceData.acondicionamento?.idResiduoAcondicionamento ||
        props.item?.idResiduoAcondicionamento ||
        null,
      residuoAcondicionamento:
        proposalServiceData.acondicionamento?.residuoAcondicionamento ||
        props.item?.residuoAcondicionamento ||
        null,
      residuoAcondicionamentoDescricao:
        proposalServiceData.acondicionamento?.descricao ||
        props.item?.residuoAcondicionamentoDescricao ||
        null,
      idResiduoEquipamento:
        proposalServiceData.equipamento?.idResiduoEquipamento || props.item?.idResiduoEquipamento || null,
      residuoEquipamento:
        proposalServiceData.equipamento?.residuoEquipamento || props.item?.residuoEquipamento || null,
      residuoEquipamentoDescricao:
        proposalServiceData.equipamento?.descricao || props.item?.residuoEquipamentoDescricao || null,
    }),
    [props.idProposta, props.item, proposalServiceData, quotationsData]
  );

  const validateQuotations = (): ProposalServiceQuotationType[] => {
    quotationsData.forEach((quotation) => {
      if (quotation.idServico !== proposalServiceData.servico?.idServico) {
        throw Error(
          `Existe(m) cotação(ões) que não se enquadram no serviço: (Serviço esperado: ${proposalServiceData.servico?.servico} | Serviço atual: ${quotation.servico})`
        );
      }

      if (proposalServiceData.tipo === EntityItemEnum.Service) {
        if (quotation.idResiduoAcondicionamento || quotation.idResiduoEquipamento) {
          throw Error(
            `Existe(m) cotação(ões) que não se enquadram no serviço: (Tipo esperado: Fornecedor | Tipo atual: ${
              quotation.idResiduoAcondicionamento ? 'Acondicionamento' : 'Equipamento'
            })`
          );
        }
      } else if (proposalServiceData.tipo === EntityItemEnum.Packaging) {
        if (!quotation.idResiduoAcondicionamento) {
          throw Error(
            `Existe(m) cotação(ões) que não se enquadram no serviço: (Tipo esperado: Acondicionamento | Tipo atual: ${
              quotation.idResiduoEquipamento ? 'Equipamento' : 'Fornecedor'
            })`
          );
        }

        if (
          quotation.idResiduoAcondicionamento !==
          proposalServiceData.acondicionamento?.idResiduoAcondicionamento
        ) {
          throw Error(
            `Existe(m) cotação(ões) que não se enquadram no serviço: (Acondicionamento: ${proposalServiceData.acondicionamento?.residuoAcondicionamento} | Tipo atual: ${quotation.residuoAcondicionamento})`
          );
        }
      } else if (proposalServiceData.tipo === EntityItemEnum.Equipment) {
        if (!quotation.idResiduoEquipamento) {
          throw Error(
            `Existe(m) cotação(ões) que não se enquadram no serviço: (Tipo esperado: Equipamento | Tipo atual: ${
              quotation.idResiduoAcondicionamento ? 'Acondicionamento' : 'Fornecedor'
            })`
          );
        }

        if (quotation.idResiduoEquipamento !== proposalServiceData.equipamento?.idResiduoEquipamento) {
          throw Error(
            `Existe(m) cotação(ões) que não se enquadram no serviço: (Equipamento: ${proposalServiceData.equipamento?.residuoEquipamento} | Tipo atual: ${quotation.residuoEquipamento})`
          );
        }
      }
    });

    return quotationsData;
  };

  const handleSubmit = () => {
    let step = 'Geral';

    try {
      const generalData = refGeneralForm.current.validate();

      step = 'Recorrência';
      let recorrenciaData = refRecorrenciaForm?.current?.validate();

      if (!recorrenciaData) {
        recorrenciaData = {};
        recorrenciaData.action = Action.Nothing;

        if (generalData.action === Action.Add) {
          recorrenciaData.action = Action.Add;
        } else if (generalData.action === Action.Modify) {
          if (generalData.idResiduoAcondicionamento || generalData.idResiduoEquipamento) {
            recorrenciaData.action = Action.Modify;
          }
        }
      }
      recorrenciaData.idPropostaRecorrencia = props.origItem?.recorrencia.idPropostaRecorrencia;
      recorrenciaData.idProposta = props.origItem?.recorrencia.idProposta;
      recorrenciaData.idPropostaServico = props.origItem?.recorrencia.idPropostaServico;

      step = 'Cotações';
      let cotacoesData = validateQuotations();
      if (generalData.precificacao?.tipo === ProposalTipoPrecificacaoEnum.Geral) {
        const generalPricing: ProposalResiduePlanPricingType = {
          ...generalData.precificacao,
        };

        cotacoesData = cotacoesData.map((quotation) => ({
          ...quotation,
          action:
            quotation.action === Action.Nothing && !!quotation.idPropostaServicoCotacao
              ? Action.Modify
              : quotation.action,
          precificacao: { ...generalPricing },
        }));
      }
      props.callback(
        {
          ...generalData,
          recorrencia: recorrenciaData,
          cotacoes: cotacoesData,
        },
        'callback',
        true
      );
    } catch (ex: any) {
      setError({
        title: step,
        message: ex.message,
      });
    }
  };

  const buildTabs = () => {
    const tabs = [
      {
        key: 'Geral',
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
              <IconId size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
              Geral
            </Text>
          </Group>
        ),
        children: (
          <ServiceGeneralFormView
            ref={refGeneralForm}
            proposalGeneralData={props.proposalGeneralData}
            callback={props.callback}
            idProposta={props.idProposta}
            item={props.item}
            origItem={props.origItem}
            referenceData={props.referenceData}
            disabled={disabled}
            zIndex={props.zIndex + 1}
          />
        ),
        forceRender: true,
      },
    ];

    if (proposalServiceData.tipo === EntityItemEnum.Service) {
      tabs.push({
        key: 'Recorrencia',
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
              <IconCalendarEvent size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
              Recorrência
            </Text>
          </Group>
        ),
        children: (
          <RecurrenceForm
            idPropostaRecorrencia={props.item?.recorrencia.idPropostaRecorrencia || null}
            title="Recorrência"
            description="Eventos personalizados a serem gerados para este serviço."
            color={Feature.Home.Proposal.color}
            minDate={props.proposalGeneralData.dataInicial}
            maxDate={props.proposalGeneralData.dataFinal}
            ref={refRecorrenciaForm}
            dataInicial={props.item?.recorrencia.dataInicial || props.proposalGeneralData.dataInicial}
            dataFinal={props.item?.recorrencia.dataFinal || props.proposalGeneralData.dataFinal}
            quantidade={props.item?.recorrencia.quantidade || null}
            cada={props.item?.recorrencia.cada || null}
            frequencia={props.item?.recorrencia.frequencia || null}
            ocorrencia={props.item?.recorrencia.ocorrencia || null}
            diasSemana={props.item?.recorrencia.diasSemana || null}
            diasMes={props.item?.recorrencia.diasMes || null}
            mesAno={props.item?.recorrencia.mesAno || null}
            disabled={false}
            zIndex={200}
          />
        ),
        forceRender: true,
      });
    }

    tabs.push({
      key: 'Cotacoes',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconZoomMoney size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Cotações
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <ServiceQuotationEditor
            data={currentServiceData}
            isEdit
            referenceData={props.referenceData}
            zIndex={props.zIndex + 1}
            initialQuotationItem={props.initialQuotationItem || null}
            initialQuotationTab={(props.initialQuotationTab as 'Cotacao' | 'Tolerancias') || 'Cotacao'}
            autoOpenQuotationModal={props.autoOpenQuotationModal || false}
            onChange={(nextService) => setQuotationsData(nextService.cotacoes)}
          />
        </Paper>
      ),
      forceRender: true,
    });

    return tabs;
  };

  return (
    <div>
      <Paper shadow="xs" p="md" withBorder>
        {error && (
          <>
            <Alert
              icon={<IconCircleX size={18} />}
              title={error.title}
              color="red"
              withCloseButton
              onClose={() => setError(null)}
            >
              {error.message}
            </Alert>
            <Space h="xl" />
          </>
        )}

        <Tabs items={buildTabs()} defaultActiveKey={props.defaultActiveKey || 'Geral'} />
      </Paper>
      <Space h="lg" />

      <Group justify="right">
        <Button leftSection={<IconDeviceFloppy size={18} />} onClick={handleSubmit}>
          Salvar
        </Button>
      </Group>
    </div>
  );
}
